import type { NavigationGuard } from 'vue-router'
import { useVisitorsStore } from '@/shared/store'
import { PurchaseFlowRoutes } from '@/shared/types/router.types'

export const travelDurationGuard: NavigationGuard = (to) => {
  const visitorsStore = useVisitorsStore()

  if (!visitorsStore.holder.visaValidityDate) {
    return {
      name: PurchaseFlowRoutes.HOLDER_INFO,
      query: to.query,
    }
  }

  return true
}
